export function Spinner() {
  return (
    <div className="row u-89d2274">
      <span className="spinner" role="status" aria-label="Loading" />
    </div>
  );
}

export function Empty({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="empty-state">
      <p className="u-7643c27">{title}</p>
      {hint && <p className="m-0">{hint}</p>}
    </div>
  );
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="error-state" role="alert">
      <p className="m-0">{message}</p>
    </div>
  );
}

/**
 * Sizing comes from CSS, not an inline style: `.logo` is 42px and
 * `.profile-header .logo` overrides to 64px. Inline styles are the last thing
 * forcing 'unsafe-inline' into our style-src, so the two sizes we actually use
 * are classes instead.
 */
export function Logo({ url, name, size = 42 }: { url: string | null; name: string; size?: number }) {
  const cls = size >= 64 ? "logo logo-lg" : "logo";
  if (url) return <img className={cls} src={url} alt="" width={size} height={size} />;
  return (
    <span className={cls} aria-hidden>
      {name.slice(0, 1).toUpperCase()}
    </span>
  );
}
